import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { BlockPicker } from 'react-color'
import { Column, Select, TextInput } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import SettingsPanel from '../../../internal/SettingsPanel'
import { getText } from '../../../internal/TextLabels'
import { DefaultCheckoutStyling } from '../../../models/constants'
import { useToggle } from '../../../util/utility-hooks'

const availableFonts = [
  { key: 'avenir', value: 'Avenir', valueLabel: 'Avenir' },
  { key: 'arial', value: 'Arial', valueLabel: 'Arial' },
  { key: 'mundo', value: 'Mundo', valueLabel: 'Mundo' },
]
const CheckoutSettings = ({
  checkoutStyling,
  termsLink: propsTermsLink,
  updateCheckoutSettings,
}) => {
  const [edit, toggleEdit] = useToggle(false)
  const [picker, togglePicker] = useToggle(false)
  const [colour, setColour] = useState(
    checkoutStyling.colour || DefaultCheckoutStyling.COLOUR,
  )
  const [font, setFont] = useState(
    checkoutStyling.font || DefaultCheckoutStyling.FONT,
  )
  const [termsLink, setTermsLink] = useState(
    propsTermsLink || DefaultCheckoutStyling.TERMS_LINK,
  )

  const save = () => {
    updateCheckoutSettings(colour, font, termsLink)
    toggleEdit()
    if (picker) {
      togglePicker()
    }
  }
  const onCancelEdit = () => {
    setColour(checkoutStyling.colour || DefaultCheckoutStyling.COLOUR)
    setFont(checkoutStyling.font || DefaultCheckoutStyling.FONT)
    setTermsLink(propsTermsLink)
    toggleEdit()
    if (picker) {
      togglePicker()
    }
  }

  const buttons = edit
    ? [
        {
          text: getText('default.cancel'),
          action: onCancelEdit,
        },
        {
          text: getText('default.save'),
          type: 'primary',
          disabled: !!(termsLink && termsLink.indexOf('http') !== 0),
          action: save,
        },
      ]
    : [
        {
          text: getText('default.edit'),
          action: toggleEdit,
        },
      ]
  return (
    <SettingsPanel
      header={getText('storeSettings.checkout.header')}
      buttons={buttons}
    >
      <Column col4>
        <label className={midas.formLabel}>
          {getText('storeSettings.checkout.font.colour')}
        </label>
      </Column>
      <Column col8>
        <div style={{ position: 'relative' }}>
          <TextInput
            id="setting-colour"
            value={colour || ''}
            onChange={e => setColour(e.target.value)}
            skipValidation
            disabled
          >
            {edit && (
              <div
                aria-label="Open colour picker"
                role="button"
                tabIndex={0}
                style={{
                  border: '1px solid lightgrey',
                  height: '3.2rem',
                  width: '3.2rem',
                  background: colour,
                  cursor: 'pointer',
                }}
                onClick={togglePicker}
                onKeyPress={togglePicker}
              />
            )}
            {!edit && (
              <div
                style={{
                  border: '1px solid lightgrey',
                  height: '3.2rem',
                  width: '3.2rem',
                  background: colour,
                }}
              />
            )}
          </TextInput>
          {edit && picker && (
            <div
              style={{
                position: 'absolute',
                right: 0,
                border: '1px solid lightgrey',
                borderRadius: '5px',
                background: 'rgba(250,250,250,1)',
                zIndex: '2',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  padding: '0.7rem',
                }}
              >
                <button
                  aria-label="Close colour picker"
                  type="button"
                  onClick={togglePicker}
                  className={[midas.button, midas.buttonClear].join(' ')}
                />
              </div>
              <div style={{ padding: '1.5rem' }}>
                <BlockPicker
                  color={colour}
                  onChangeComplete={c => setColour(c.hex)}
                  triangle="hide"
                />
              </div>
            </div>
          )}
        </div>
      </Column>
      <Column col4>
        <label className={midas.formLabel}>
          {getText('storeSettings.checkout.font.type')}
        </label>
      </Column>
      <Column col8>
        <div style={{ width: '100%' }}>
          <Select
            id="type-select"
            values={availableFonts.filter(f => f.value !== font)}
            disabled={!edit}
            value={font}
            optionsLabel={font}
            onChange={setFont}
          />
        </div>
      </Column>
      <Column col4>
        <label className={midas.formLabel}>
          {getText('storeSettings.checkout.termsLink.label')}
        </label>
      </Column>
      <Column col8>
        <div style={{ width: '100%' }}>
          <TextInput
            id="settings-terms-link"
            value={termsLink || ''}
            onChange={e => setTermsLink(e.target.value)}
            required={getText('storeSettings.checkout.termsLink.required')}
            disabled={!edit}
          />
        </div>
      </Column>
    </SettingsPanel>
  )
}

CheckoutSettings.propTypes = {
  checkoutStyling: PropTypes.object.isRequired,
  termsLink: PropTypes.string,
  updateCheckoutSettings: PropTypes.func.isRequired,
}

CheckoutSettings.defaultProps = {
  termsLink: null,
}

export default CheckoutSettings
